import { createContext, useContext } from 'react';

export const ChatStoreContext = createContext(null);

export const useChatStore = () => {
  const context = useContext(ChatStoreContext);

  if (!context) {
    throw new Error('useChatStore must be used within a ChatStoreContext provider');
  }

  return context;
};
